import { ColumnState } from 'ag-grid-community/dist/lib/columnController/columnController';

export class GridSettingsData {
  public columnState: ColumnState[];
  public filterModel: any;
  public sortModel: any;
}
